// extracted by css-extract-rspack-plugin
export default {"actionIcon":"BankDetailsStatusAction_actionIcon__GskmJ"};